import type { ComputedRef, InjectionKey } from 'vue';
import { RouteLocationRaw } from 'vue-router';

export const ProductBrowsePageTitleKey: InjectionKey<ComputedRef<string>> = Symbol('productBrowsePageTitle');
export const IsPlaPageKey: InjectionKey<string | boolean> = Symbol('isPlaPage');
export const ProductBrowsePageRouteKey: InjectionKey<ComputedRef<RouteLocationRaw>> = Symbol('productBrowsePageRoute');
